import { render, staticRenderFns } from "./loginCallback.vue?vue&type=template&id=708e21b2&"
import script from "./loginCallback.vue?vue&type=script&lang=js&"
export * from "./loginCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports